import { createSelector, createFeatureSelector } from '@ngrx/store';
import { IRegistrationState, IRegistrationStatusState } from '../../state/registration.state';
import { Features } from 'src/app/models/features';

export const getRegistrationState = createFeatureSelector<IRegistrationState>(Features.REGISTRATION);

export const selectRegistrationStatusState = createSelector(
    getRegistrationState,
    (state: IRegistrationState) => state.status
);

export const selectRegistrationFailText = createSelector(
    selectRegistrationStatusState,
    (state: IRegistrationStatusState) => state.failText
);

export const selectRegistrationStatus = createSelector(
    selectRegistrationStatusState,
    (state: IRegistrationStatusState) => state.status
);
